import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { Search } from '../../Filter/index';
import QAContext from '../../../context/QAContext';

const { bool, number } = proptypes;

export const Header = ({ showTitleWithTotalQns = true, seoData = null }) => {
  let { channel, TotalResults, seoPageNumber } = useContext(QAContext);

  if (seoPageNumber && seoData) TotalResults = seoData;

  return (
    <div className="sui-w-full sui-mb-4">
      <div className="sui-w-full">
        <Search nopadding />
      </div>
    </div>
  );
};

Header.displayName = 'Header';

Header.propTypes = {
  showTitleWithTotalQns: bool,
  seoData: number
};
